import React from "react";
import Icon from "./Icon";
import { Skill } from "../data/portfolio";

interface SkillCardProps {
  skill: Skill;
}

const SkillCard: React.FC<SkillCardProps> = ({ skill }) => {
  return (
    <div className="flex flex-col items-center gap-2 cursor-target">
      <Icon icon={skill.icon} className="text-4xl" />
      <span className="text-sm lg:text-xs xl:text-sm text-center">{skill.label}</span>
    </div>
  );
};

export default SkillCard;
